import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Summary, Tag } from 'src/services/tag/Tag';
import { offlineTags } from './data/offlineTags';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  public tags = new BehaviorSubject<Tag[]>([]);
  public static readonly DEFAULT_COLOR: string = 'green';
  public static readonly DEFAULT_SUMMARY: Summary = Summary.none;

  constructor() {}

  async save(tags: Tag[]): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async updateById(tag: Tag): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async deleteById(id: string): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async create(fullPath: string, isPeriodic?: boolean): Promise<string> {
    throw new Error('Method not implemented.');
  }

  async duplicate(id: string): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async archive(id: string): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async archiveWithTree(tag: Tag, setToArchiveTrue = true): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async unarchive(ud: string): Promise<void> {
    throw new Error('Method not implemented.');
  }

  async createSubPathsIfNecessary(fullPath: string): Promise<void> {
    throw new Error('Method not implemented.');
  }

  getNewId(): string {
    throw new Error('Method not implemented.');
  }
}
